<!-- eslint-disable vue-a11y/form-has-label -->
<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="scoroProducts">
    <p v-if="productsWithoutCode" class="disclaimer">
      Rasta {{ productsWithoutCode }} prekė(-ės) be kodo. Užpildykite raudonus langelius. Prekės, neturinčios kodo, nebus siunčiamos į Directo!
    </p>

    <Row class="headerRow no-gutters">
      <Column :sm="3">
        Pavadinimas
      </Column>
      <Column :sm="3">
        Kodas
      </Column>
      <Column :sm="3">
        Grupė
      </Column>
      <Column :sm="3">
        Kiekis
      </Column>
    </Row>
    <Row v-for="(product, indexRow) in productRows" :key="indexRow" class="tableRow no-gutters">
      <Column v-for="(spec, indexCol) in Object.values(product)" :key="indexCol" :sm="3">
        <input
          v-if="editableColumnIndexes.includes(indexCol)"
          v-model="productRows[indexRow][getCell(product, indexCol)]"
          class="cellEditable"
          :class="{ missing: !productRows[indexRow][getCell(product, indexCol)] }">
        <div v-else class="cell">
          {{ spec }}
        </div>
      </Column>
    </Row>
  </div>
</template>

<script>

export default {
  props: {
    products: Array,
  },
  data() {
    return {
      editableColumnIndexes: [1],
      productRows: this.products,
    }
  },
  computed: {
    productsWithoutCode() {
      return this.productRows.filter(productRow => !productRow.code).length
    },
  },
  methods: {
    getCell(productObject, index) {
      return Object.keys(productObject)[index]
    },
  },
}
</script>

<style lang="scss">
.scoroProducts {
  margin-top: 2rem;

  .disclaimer {
    color: $red;
    font-size: 1rem;
    margin: 2rem 0;
  }

  .headerRow {
    font-weight: $semibold;
  }

  .tableRow {
    border-bottom: 1px solid $black;
    margin: 1rem 0;
  }

  .cellEditable {
    width: 100%;

    &.missing {
      background: $red;
    }
  }

  .cell {
    // border: 1px solid $black;
    padding: 5px;
  }
}
</style>
